import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "overflow-x-auto" }
const _hoisted_3 = { class: "align-middle inline-block min-w-full" }
const _hoisted_4 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "table-fixed min-w-full divide-y divide-gray-200"
}
const _hoisted_7 = { class: "bg-gray-50" }
const _hoisted_8 = {
  colspan: "6",
  class: "border-b"
}
const _hoisted_9 = { class: "p-3" }
const _hoisted_10 = {
  key: 0,
  scope: "col",
  width: "70px",
  style: {"min-width":"70px"},
  class: "px-4 py-3 text-center text-xs font-medium text-gray-500 border-r"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  width: "130px",
  style: {"min-width":"130px"},
  class: "px-4 py-3 text-center text-xs font-medium text-gray-500 border-r"
}, " Time ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"150px"},
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " Project ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"150px"},
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " Task ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  style: {"min-width":"150px"},
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " Comment ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  width: "50px",
  style: {"min-width":"50px"},
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500"
}, " Actions ", -1)
const _hoisted_16 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "100%",
  class: "px-3 py-2 text-gray-500 text-sm"
}, "No records for selected parameters.", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "px-3 py-2 border-r"
}
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { class: "px-3 py-2 border-r" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-1 border border-r-0 border-l-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, "h", -1)
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-1 border rounded-r-md border-gray-200 bg-gray-50 text-gray-500 text-sm" }, "m", -1)
const _hoisted_28 = { class: "px-3 py-2 border-r" }
const _hoisted_29 = { class: "mt-1" }
const _hoisted_30 = { class: "relative w-full text-left cursor-default sm:text-sm overflow-hidden form-select rounded-md text-sm text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200" }
const _hoisted_31 = {
  key: 0,
  class: "cursor-default select-none relative py-2 px-4 text-gray-700 text-sm"
}
const _hoisted_32 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3"
}
const _hoisted_33 = {
  key: 1,
  class: "cursor-default select-none relative py-2 px-4 text-gray-400 text-xs italic border-t border-gray-100"
}
const _hoisted_34 = { class: "px-3 py-2 border-r" }
const _hoisted_35 = { class: "mt-1" }
const _hoisted_36 = { class: "relative w-full text-left cursor-default sm:text-sm overflow-hidden form-select rounded-md text-sm text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Use \"")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("\" ")
const _hoisted_39 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3"
}
const _hoisted_40 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3"
}
const _hoisted_41 = { class: "px-3 py-2 border-r" }
const _hoisted_42 = ["onUpdate:modelValue"]
const _hoisted_43 = { class: "px-3 py-2 flex align-middle justify-end" }
const _hoisted_44 = { class: "bg-gray-50" }
const _hoisted_45 = { colspan: "100%" }
const _hoisted_46 = { class: "flex justify-end px-3 py-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "Add 5 records", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, "Add record", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_report_progress = _resolveComponent("report-progress")!
  const _component_ComboboxInput = _resolveComponent("ComboboxInput")!
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_ComboboxButton = _resolveComponent("ComboboxButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ComboboxOption = _resolveComponent("ComboboxOption")!
  const _component_ComboboxOptions = _resolveComponent("ComboboxOptions")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_Combobox = _resolveComponent("Combobox")!
  const _component_DuplicateIcon = _resolveComponent("DuplicateIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.dataLoaded || !_ctx.projectsLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Loading "))
            : (_openBlock(), _createElementBlock("table", _hoisted_6, [
                _createElementVNode("thead", _hoisted_7, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_report_progress, {
                          reportedTime: _ctx.reportedTime,
                          allocatedTime: _ctx.allocatedTime,
                          labels: true
                        }, null, 8, ["reportedTime", "allocatedTime"])
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    (_ctx.dataMode == 'month')
                      ? (_openBlock(), _createElementBlock("th", _hoisted_10, " Date "))
                      : _createCommentVNode("", true),
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_16, [
                  (_ctx.records.length == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (record, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "hover:bg-gray-50",
                      key: record
                    }, [
                      (_ctx.dataMode == 'month')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                            _withDirectives(_createElementVNode("input", {
                              ref_for: true,
                              ref: "date",
                              "onUpdate:modelValue": ($event: any) => ((record.date) = $event),
                              type: "text",
                              onFocus: _cache[0] || (_cache[0] = ($event: any) => ($event.target.select())),
                              class: "w-full rounded-md border-gray-200 text-sm text-gray-700 text-center"
                            }, null, 40, _hoisted_21), [
                              [_vModelText, record.date]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _withDirectives(_createElementVNode("input", {
                            ref_for: true,
                            ref: "hours",
                            "onUpdate:modelValue": ($event: any) => ((record.hours) = $event),
                            type: "text",
                            inputmode: "numeric",
                            onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select())),
                            class: "w-full rounded-l-md border-gray-200 text-sm text-gray-700 px-1 text-center"
                          }, null, 40, _hoisted_24), [
                            [
                              _vModelText,
                              record.hours,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _hoisted_25,
                          _withDirectives(_createElementVNode("input", {
                            ref_for: true,
                            ref: "minutes",
                            "onUpdate:modelValue": ($event: any) => ((record.minutes) = $event),
                            type: "text",
                            inputmode: "numeric",
                            onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select())),
                            class: "w-full border-gray-200 border-r-0 text-sm text-gray-700 px-1 text-center"
                          }, null, 40, _hoisted_26), [
                            [
                              _vModelText,
                              record.minutes,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _hoisted_27
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_28, [
                        _createVNode(_component_Combobox, {
                          modelValue: record.project,
                          "onUpdate:modelValue": ($event: any) => ((record.project) = $event)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_ComboboxInput, {
                                  class: "w-full border-none focus:ring-0 py-2 pl-3 pr-10 text-sm leading-5 text-gray-700",
                                  displayValue: (projectID) => _ctx.getProjectLabel(projectID),
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select())),
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.queryProject = $event.target.value))
                                }, null, 8, ["displayValue"]),
                                _createVNode(_component_ComboboxButton, { class: "absolute inset-y-0 right-0 flex items-center pr-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_SelectorIcon, {
                                      class: "w-5 h-5 text-gray-400",
                                      "aria-hidden": "true"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_TransitionRoot, {
                                leave: "transition ease-in duration-100",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                onAfterLeave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.queryProject = ''))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ComboboxOptions, { class: "absolute w-auto left-2 right-2 sm:left-auto sm:right-auto py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 md:max-h-96 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10" }, {
                                    default: _withCtx(() => [
                                      (_ctx.filteredProjects.length === 0 && _ctx.queryProject !== '')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " No projects found. "))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProjects, (project) => {
                                        return (_openBlock(), _createBlock(_component_ComboboxOption, {
                                          as: "template",
                                          key: project.id,
                                          value: project.id
                                        }, {
                                          default: _withCtx(({ selected, active }) => [
                                            _createElementVNode("li", {
                                              class: _normalizeClass(["cursor-default select-none relative py-2 pl-10 pr-4 text-gray-700 text-sm", {
                                'bg-indigo-100': active,
                              }])
                                            }, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["block truncate", { 'font-medium': selected, 'font-normal': !selected }])
                                              }, [
                                                (!_ctx.isPromptOption(project.id))
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 0,
                                                      class: _normalizeClass(["mr-2 text-xs font-semibold text-center p-1 rounded-md text-indigo-600 bg-indigo-100", {'bg-indigo-200': active}])
                                                    }, _toDisplayString(project.id), 3))
                                                  : _createCommentVNode("", true),
                                                _createTextVNode(_toDisplayString(project.name), 1)
                                              ], 2),
                                              selected
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                                    _createVNode(_component_CheckIcon, {
                                                      class: "w-5 h-5",
                                                      "aria-hidden": "true"
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128)),
                                      (_ctx.hasMoreProjects)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Type to search more projects… "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_34, [
                        _createVNode(_component_Combobox, {
                          modelValue: record.task,
                          "onUpdate:modelValue": ($event: any) => ((record.task) = $event)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createVNode(_component_ComboboxInput, {
                                  class: "w-full border-none focus:ring-0 py-2 pl-3 pr-10 text-sm leading-5 text-gray-700",
                                  displayValue: (task) => _ctx.getTaskDisplayValue(record.project, task),
                                  onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select())),
                                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.queryTask = $event.target.value))
                                }, null, 8, ["displayValue"]),
                                _createVNode(_component_ComboboxButton, { class: "absolute inset-y-0 right-0 flex items-center pr-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_SelectorIcon, {
                                      class: "w-5 h-5 text-gray-400",
                                      "aria-hidden": "true"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_TransitionRoot, {
                                leave: "transition ease-in duration-100",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                onAfterLeave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.queryTask = ''))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ComboboxOptions, { class: "absolute w-auto left-2 right-2 sm:left-auto sm:right-auto py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 md:max-h-96 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10" }, {
                                    default: _withCtx(() => [
                                      (!_ctx.hasRequiredTask(record.project) && _ctx.queryTask)
                                        ? (_openBlock(), _createBlock(_component_ComboboxOption, {
                                            key: 0,
                                            value: _ctx.queryTask
                                          }, {
                                            default: _withCtx(({selected, active}) => [
                                              _createElementVNode("li", {
                                                class: _normalizeClass(["cursor-default select-none relative py-2 pl-10 pr-4 text-gray-700 text-sm", {
                                'bg-indigo-100': active,
                              }])
                                              }, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["block truncate", { 'font-medium': selected, 'font-normal': !selected }])
                                                }, [
                                                  _hoisted_37,
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.queryTask), 1),
                                                  _hoisted_38
                                                ], 2),
                                                selected
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                                      _createVNode(_component_CheckIcon, {
                                                        class: "w-5 h-5",
                                                        "aria-hidden": "true"
                                                      })
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 2)
                                            ]),
                                            _: 1
                                          }, 8, ["value"]))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProjectTasks(record.project), (task) => {
                                        return (_openBlock(), _createBlock(_component_ComboboxOption, {
                                          as: "template",
                                          key: task.id,
                                          value: task.id
                                        }, {
                                          default: _withCtx(({ selected, active }) => [
                                            _createElementVNode("li", {
                                              class: _normalizeClass(["cursor-default select-none relative py-2 pl-10 pr-4 text-gray-700 text-sm", {
                                'bg-indigo-100': active,
                              }])
                                            }, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["block truncate", { 'font-medium': selected, 'font-normal': !selected }])
                                              }, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["mr-2 text-xs font-semibold text-center p-1 rounded-md text-indigo-600 bg-indigo-100", {'bg-indigo-200': active}])
                                                }, _toDisplayString(task.id), 3),
                                                _createTextVNode(" " + _toDisplayString(task.name), 1)
                                              ], 2),
                                              selected
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                                    _createVNode(_component_CheckIcon, {
                                                      class: "w-5 h-5",
                                                      "aria-hidden": "true"
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_41, [
                        _withDirectives(_createElementVNode("input", {
                          ref_for: true,
                          ref: "comment",
                          "onUpdate:modelValue": ($event: any) => ((record.comment) = $event),
                          type: "text",
                          class: "w-full rounded-md border-gray-200 text-sm text-gray-700"
                        }, null, 8, _hoisted_42), [
                          [_vModelText, record.comment]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_43, [
                        _createVNode(_component_app_button, {
                          onClick: ($event: any) => (_ctx.duplicateRecord(index)),
                          type: "green",
                          padding: "small",
                          class: _normalizeClass(['mr-1']),
                          title: "Duplicate"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DuplicateIcon, { class: "h-5 w-5" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_app_button, {
                          onClick: ($event: any) => (_ctx.removeRecord(index)),
                          type: "red",
                          padding: "small",
                          title: "Remove"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_XIcon, { class: "h-5 w-5" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", null, [
                  _createElementVNode("tr", _hoisted_44, [
                    _createElementVNode("td", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_app_button, {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addRecords(5))),
                          type: "green",
                          class: _normalizeClass(['w-full sm:w-auto mr-0.5'])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_PlusIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                            _hoisted_47
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_app_button, {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addRecords(1))),
                          type: "green",
                          class: _normalizeClass(['w-full sm:w-auto ml-0.5'])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_PlusIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                            _hoisted_48
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ])
                    ])
                  ])
                ])
              ]))
        ])
      ])
    ])
  ]))
}